import { CamelCasedPropertiesDeep } from "./conversion-types";

export enum BatchEntityType {
  AdAssetGroup = "ad_asset_group"
}

export interface BatchServerResponse {
  id: number;
  name: string;
  type: BatchType;
  status: BatchStatus;
  concept?: {
    id: string;
    name: string;
  };
  count: number;
  brand_id: number;
  created_at: string;
  info: string;
  updated_at: string;
  result_metadata: string;
  result_metadata_schema_version: string;
  creator_id: number;
  variation_set_id?: number;
  entity_id?: number;
  entity_type?: BatchEntityType;
}

export enum BatchType {
  ImageGenerate = "image_generate",
  VideoGenerate = "video_generate",
  VariationGenerate = "variation_generate",
  ImageGenerateFromConcept = "image_generate_from_concept",
  ImageUpload = "image_upload",
  AdAssetGroupPublish = "ad_asset_group_publish",
  DatasetCaptioning = "dataset_captioning",
  LoraTraining = "lora_training",
  BulkImageGeneration = "bulk_image_generation",
  ResizingImageGeneration = "resizing_image_generation"
}

export enum BatchStatus {
  Created = "created",
  Processing = "processing",
  Pending = "pending",
  Completed = "completed",
  Failed = "failed",
  PartialSuccess = "partial_success"
}

export type Batch = CamelCasedPropertiesDeep<
  Omit<BatchServerResponse, "result_metadata" | "result_metadata_schema_version" | "info">
> & {
  result: object;
  info: Record<string, string>;
  confirmed: boolean;
};

export interface ImageGenerationResult {
  failed: number;
  failures: string[];
  succeeded: number;
}

export interface VideoGenerationResult {
  failed: number;
  failures: string[];
  succeeded: number;
}

export interface ImageGenerationBatch extends Batch {
  type: BatchType.ImageGenerate;
  result: ImageGenerationResult;
}

export interface VideoGenerationBatch extends Batch {
  type: BatchType.VideoGenerate;
  result: VideoGenerationResult;
}
